import { type FC } from 'react'
import { type DefaultProps } from '@egw/components'

export const NfcIcon: FC<DefaultProps> = ({ className, id, testId, ariaLabel }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <path
        fill="#698679"
        d="M10.5 2.985v6.03A1.486 1.486 0 0 1 9.015 10.5H5.791L4.393 9.381V3.625l2.333 2.59a.321.321 0 1 0 .476-.43L4.31 2.57a.317.317 0 0 0-.353-.083.322.322 0 0 0-.206.299v6.75a.322.322 0 0 0 .122.25l.89.714H2.986A1.486 1.486 0 0 1 1.5 9.015v-6.03A1.486 1.486 0 0 1 2.985 1.5h3.224l1.398 1.119v5.756l-2.333-2.59a.321.321 0 1 0-.476.43L7.69 9.43a.321.321 0 0 0 .559-.216v-6.75a.322.322 0 0 0-.122-.25l-.89-.714h1.777A1.486 1.486 0 0 1 10.5 2.985Z"
      />
    </svg>
  )
}
